import React from 'react'
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom'

import { isLoggedIn } from '../../utils/auth'
import Login from '../../pages/user/Login'
// import Login from '../../pages/user/Login/index_bk'
import ConfirmUserA1 from '../../pages/user/ConfirmUserA1'
import ConfirmUserA2 from '../../pages/user/ConfirmUserA2'
import SetPasswordsFirstTime from '../../pages/user/SetPasswordsFirstTime'
import SiderLayout from '../../components/user/SiderLayout'
import ForgetPassword from '../../pages/user/ForgetPassword'
import NotFound from '../../pages/user/NotFound'

function App() {
	// console.log  = console.warn = console.error = () => { };
   
	return (
		<BrowserRouter>
			<Switch>
				<Route path="/login" exact component={Login} />
				{/* <Route path="/MockupIframe" exact component={MockupIframe} /> */}
				<Route path="/verify/user/A1" exact component={ConfirmUserA1} />
				<Route path="/verify/user/A2" exact component={ConfirmUserA2} />
				{/* <Route path="/verify/user" exact component={ConfirmUser} /> */}
				<Route path="/forgetpassword" exact component={ForgetPassword} />
				<Route path="/passwords/first/time" exact component={SetPasswordsFirstTime} />
				{isLoggedIn() && <Route path="/" component={SiderLayout} />}
				{!isLoggedIn() && <Redirect to="/login" />}
				{/* {<Route path="/" component={SiderLayout} />} */}
				<Route component={NotFound} />
			</Switch>
		</BrowserRouter>
	)
}

export default App